export const lazyRoute = (
  getImport: () => Promise<{ default: React.ComponentType }>,
) => {
  return async () => {
    const { default: Component } = await getImport();
    return { Component };
  };
};
